import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { TranslationsResponse } from '../../models/intefaces/translations-response';

const empty: TranslationsResponse = {
  steps: [],
  contents: { howTo: { 'step-descriptions': [] } },
  translations: {},
  authenticated: false,
  session: '',
  api_url: '',
  partner_token: '',
};

export enum Platform {
  mobile,
  desktop,
}

@Injectable({
  providedIn: 'root',
})
export class TranslationsService {
  private translationsCache: TranslationsResponse = empty;

  private platform = Platform.desktop;

  private error?: HttpErrorResponse;

  private currentLanguage = '';

  private readonly isReady = new BehaviorSubject(false);
  get ready(): Observable<boolean> {
    return this.isReady.asObservable();
  }

  constructor(private readonly httpClient: HttpClient) {}

  setPlatform(platform: Platform): void {
    this.platform = platform;
  }

  getPlatform(): Platform {
    return this.platform;
  }

  hasError(): boolean {
    return this.error instanceof HttpErrorResponse;
  }

  getError(): HttpErrorResponse {
    return this.error as HttpErrorResponse;
  }

  getCurrentLanguage(): string {
    return this.currentLanguage;
  }

  fetch(language: string): Observable<TranslationsResponse> {
    this.currentLanguage = language;
    const prefix = this.platform === Platform.desktop ? '' : 'mobile-';
    return this.getCacheFrom(`${language}/form/${prefix}translations`).pipe(
      catchError((error) => {
        this.error = error;
        this.isReady.next(true);
        return throwError(error);
      })
    );
  }

  private getCacheFrom(url: string): Observable<TranslationsResponse> {
    return this.httpClient.get<TranslationsResponse>(url).pipe(
      tap((translations) => {
        this.translationsCache = translations;
        this.isReady.next(true);
      })
    );
  }

  getTranslations(): TranslationsResponse {
    return this.translationsCache;
  }

  getContent<T>(name: string): T {
    return this.getTranslations().contents[name];
  }

  getValue(key: any): string {
    return this.translationsCache.translations[key];
  }
}
